module.exports = __webpack_public_path__ + "static/dmon-015-46473e087b489e55ade0d00ccb3f568c.jpg";